// Project versioning: the trail row a transport-mapping change carries. The trail is a
// display-only log — summary + optional entity label, shown on the history page. It is NOT state:
// a revision's transport rows live in project_transport / project_transport_mapping themselves,
// scoped by revision_id, so nothing folds trail snapshots back into reads any more and the
// full-state snapshot payloads this file used to build are gone with them.

export interface TransportVersionDescriptor {
  projectId: string;
  operation: "create" | "update" | "delete";
  summary: string;
  entityId?: string | null;
  entityLabel?: string | null;
}

/** The projectVersion_insert_input for a transport-mapping change (presets stamp the rest). */
export const buildTransportVersionInput = ({
  projectId,
  operation,
  summary,
  entityId,
  entityLabel,
}: TransportVersionDescriptor) => ({
  projectId,
  entityType: "transport",
  operation,
  summary,
  entityId: entityId ?? null,
  entityLabel: entityLabel ?? null,
  changes: [],
});
